import React, { Component } from 'react'
import PropTypes from 'prop-types'
import '../styles/client.css'

class Client extends Component {
  render () {
    const {logo} = this.props.logo
    return (
      <div className='client' style={{background: 'url(https://storage.googleapis.com/bronze-labs-static/images/clients/' + logo + ') no-repeat center center'}} />
    )
  }
}

Client.propTypes = {
  logo: PropTypes.object
}

export default Client



// WEBPACK FOOTER //
// ./src/components/Client.js